import {gsap} from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";

gsap.registerPlugin(DrawSVGPlugin);
gsap.registerPlugin(ScrollTrigger);

let $block = $('.block-hero-photo-video')

export function heroPhotoVideoAnimationsAfterLoader(){
  gsap.to($block.find('.photo-video-c'), { scale: 1, duration: 2 })

  let tl = gsap.timeline()
  tl.to( $block.find('h2'), { opacity: 1, top: 0, duration: 0.4, ease: 'power2'})
  tl.to( $block.find('p'), { opacity: 1, top: 0, duration: 0.4, ease: 'power2'})

  gsap.fromTo('.js-scroll-down circle', {drawSVG: '0% 0%'}, {drawSVG: '0% 100%', duration: 1})


}


if ($block.length){
  let video = $block.find('video')

  if (video.length) {
    ScrollTrigger.create({
      trigger: ".block-hero-photo-video",
      start: "bottom top",
      once: false,
      //markers: true,
      onEnter: () => {
        video[0].pause()
        video.addClass('paused')
      },
      onLeaveBack: () => {
        video[0].play()
        video.removeClass('paused')
      }
    });
  }


}
